import {IPayloadAction} from 'core/store'
import {Path} from 'history'
import * as actions from './actionTypes'

export interface IActionHistoryPush extends
  IPayloadAction<typeof actions.HISTORY_PUSH_REQUEST, Path> {}

/**
 * Action to direct the browser to the `Path` specified by `payload` and adds it as a browser history entry
 * @param payload path to direct the browser to
 */
export const historyPushRequest = (payload: Path): IActionHistoryPush => ({
  type: actions.HISTORY_PUSH_REQUEST,
  payload,
})



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/history/actions.ts